import { getPasteShortcutQueryKey } from '#pplx/frontend/apps/ask/queries/query-keys/tasksKeys.js';
import { pasteShortcut } from '#pplx/frontend/apps/ask/queries/shortcut-queries/pasteShortcut.js';
import { useQuery } from '#pplx/frontend/react-query/useQuery.js';
import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
export const usePasteShortcutQuery = ({ reason, }) => {
    const searchParams = useSearchParams();
    const copyToken = typeof searchParams?.get('c') === 'string'
        ? searchParams.get('c')
        : Array.isArray(searchParams?.get('c'))
            ? searchParams.get('c')?.[0]
            : undefined;
    const query = useQuery({
        queryKey: getPasteShortcutQueryKey(copyToken ?? ''),
        queryFn: () => pasteShortcut({ copyToken: copyToken ?? '', reason }),
        enabled: !!copyToken,
    });
    const shortcut = !query.isLoading ? (query.data?.shortcut ?? null) : null;
    return {
        query,
        shortcut,
        copyToken,
    };
};
//# sourceMappingURL=usePasteShortcutQuery.js.map